import {useStore} from "vuex";
import {useRoute} from "vue-router";
import useLanderTracker from "./landerTracker";
import {computed, ref} from "vue";
import {parseJwt} from "../helper";

export default function useThanq(productCode) {
    const store = useStore();
    const route = useRoute();
    const {fireConvPixels} = useLanderTracker(false);

    const convPixelOrigin = route.query.pxorig ? route.query.pxorig : location.origin; //Origin for pixel url.
    const convPixelPath = route.query.pxcb; //callback for conv pixel; required when returning from successful upsell
    const tp = route.query?.tp;

    const data = ref({});
    const upsells = ref([]);

    const parseUpsells = (token) => {
        let tokenData = parseJwt(token);
        if (tokenData?.u && tokenData.u.length > 0) {
            for(let i = 0; i < tokenData.u.length; i++) {
                let upsl = tokenData.u[i];
                let url = new URL('https://' + upsl.d + upsl.cb);
                url.searchParams.set('autht', token);
                upsells.value.push({
                    product: upsl.p,
                    domain: url.host,
                    origin: url.origin,
                    thanqUrl: url.toString()
                });
            }
        }
    }
    if (route.query.autht) {
        //Not a revisit/refresh; update header, session and load pixels
        store.commit('setLanderToken', route.query.autht);
        parseUpsells(route.query.autht);

        if (convPixelPath) {
            //Remove query params so they won't appear on refresh
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);
            params.delete('pxcb');
            params.delete('pxorig');
            window.history.replaceState({}, '', route.path + (params.toString() ? "?" + params.toString() : ""));
            //Pixels should be loaded with the same domain through wich product was subscribed, irrespective of product's actual domain
            fireConvPixels(new URL(convPixelPath, convPixelOrigin));
        }
    }
    store.dispatch('getThanqPageData', {productCode, tp}).then(response => {
        if(response.data.success) {
            data.value = response.data.data;
            setServerState(response.data.data);
        }
    });

    const setServerState = (data) => {
        store.commit('setBenefits', data.subscription?.benefits);
        store.commit('setCurrency', data.currency);
        store.commit('setOptions', {'theme': '2'});
        store.commit('setProduct', data.product);
        store.commit('setTrustPilot', data.trustPilot);
    }

    return {upsells, data};

}
